import { createSvgIcon } from '@mui/material';

export const BulbIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none">
    <path
      d="M7.99996 14.2829V14.8285C7.99996 15.3735 7.82483 16.4982 8.1999 16.8835C8.57498 17.2689 9.46947 17.5 9.9999 17.5C10.5303 17.5 11.4248 17.2689 11.7999 16.8835C12.175 16.4982 12 15.3735 12 14.8285V14.2829M7.99996 14.2829C7.99996 13.3633 7.64396 12.4807 7.01196 11.8314L6.46396 11.2694C5.76482 10.5509 5.28875 9.63549 5.09593 8.63899C4.90311 7.6425 5.00221 6.60964 5.38068 5.671C5.75916 4.73237 6.40002 3.93012 7.22224 3.36569C8.04446 2.80126 9.0111 2.5 9.99995 2.5C10.9888 2.5 11.9554 2.80126 12.7777 3.36569C13.5999 3.93012 14.2407 4.73237 14.6192 5.671C14.9977 6.60964 15.0968 7.6425 14.904 8.63899C14.7112 9.63549 14.2351 10.5509 13.536 11.2694L12.988 11.8314C12.6747 12.1533 12.4262 12.5355 12.2566 12.9562C12.0871 13.3768 11.9999 13.8276 12 14.2829M7.99996 14.2829H9.9999M12 14.2829H9.9999M9.9999 14.2829L9.99995 8.40876H7.99996H12"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>,
  'Bulb',
);
